export default {"src":"/_next/static/media/arrow.ed66fa13.svg","height":13,"width":7,"blurWidth":0,"blurHeight":0};